import { ServerOfferStatus } from '@yoop/server-model/token-info';
import { requestedAndNotLost } from './requested-and-not-lost';

/**
 * Predicate for requested offers
 * @param offer
 */
export const requested: (offer: { offerStatus?: ServerOfferStatus }) => boolean = (offer: {
  offerStatus?: ServerOfferStatus;
}): boolean =>
  requestedAndNotLost(offer) || (offer && offer.offerStatus === ServerOfferStatus.LOST);
